import { t } from "@lingui/macro";
import {StorageKey} from "../../../../../enums/StorageKey";
import { getColumns } from "./CashSummary";

export default {
    storageKey: StorageKey.report_cash_purchase_summary,
    getReportLabel: () => t`Cash Purchase Summary`,
    required: [
        'date',
        'number',
        'base_amount',
    ],
    defaulto: [
        'payment_methods',
        'contact_name',
        'description',
    ],
    getColumns,
};
